import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import { ContrareciboDtoList } from "../../contrarecibos/list/listmem";
import { createSelector } from "reselect";
import { observeResource } from "kea-resource";
import { componentToRx, history } from "app/main/std";

interface Props {
    value: models.ViajeCobranzaDto;
}

class ViajeCobranzaFormNoRx extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    getField = kea.formfields(() => ({
        ... this.props,
        readonly: true
    }));

    idViaje = createSelector(this.value, x => x.IdRegistro);
    filtroFac = createSelector(this.idViaje, id => ({
        IdViajeCobranza: id
    } as models.FiltroFacturas));

    facturas = createSelector(this.filtroFac, filtro => observeResource(resources.Factura.Query, filtro));

    onImprimir = async () => {
        const data = await resources.Cobranza2.ImprimirViaje(this.props.value.IdRegistro);
        kea.printPdf(data);
    }

    render() {
        const Text = this.getField(kea.Text);
        const Number = this.getField(kea.Number);
        const Date = this.getField(kea.DateTime);
        const facturas = this.facturas(this.props);

        return (
            <div>
                <kea.Title titulo="Viaje de cobranza" 
                    onRegresar={() => history.go("../")} 
                    >
                    <kea.Button onClick={this.onImprimir}>
                        Imprimir
                    </kea.Button>
                </kea.Title>
                {kea.autogrid(3, [
                    <Text field="Folio" />,
                    <Text field="NombreSucursal" />,
                    <Date field="FechaCreacion" />,
                    <Number field="CantFacturasPagadas" label="Facturas pagadas" />,
                    <Number field="SaldoFacturas" label="Saldo" format="currency" />,
                    <Number field="TotalFacturas" label="Total" format="currency" />,
                ])}

                <kea.Title titulo="Facturas" size="h4" />
                <ContrareciboDtoList items={facturas} />
            </div>
        )
    }
}

export const ViajeCobranzaForm = componentToRx(ViajeCobranzaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/edit/form.tsx